import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationDataService } from '../../../services/application.service';
import { ProspectTourCard } from 'app/models/prospect-tour-card';
import { ProspectService } from 'services/prospect.service';
import { EventEmitterService } from 'services/event-emitter.service';
import { ErrorService } from 'services/error.service';
import { LocateAgreeComponent } from '../selftour-verify-base/locate-agree/locate-agree.component';
import { MatDialog } from '@angular/material/dialog';
import { AddTourToCalendarComponent } from '../add-tour-to-calendar/add-tour-to-calendar.component';
import { AddSelfTourToCalendarComponent } from '../add-self-tour-to-calendar/add-self-tour-to-calendar.component';
import { zoneTourStartTimes } from 'app/interface/zoneTourStartTimes';

@Component({
  selector: 'app-tour-dashboard',
  templateUrl: './tour-dashboard.component.html',
  styleUrls: ['./tour-dashboard.component.css'],
  entryComponents: [LocateAgreeComponent],
})

export class TourDashboardComponent implements OnInit {
  errorMessage: string = null;
  tourCards: ProspectTourCard[] = [];
  showCancelDialog: boolean = false;
  showTourModal: boolean = false;
  tourUnavailableDialog: boolean = false;
  cancelRecordKey: number = null;
  cancelRedirectURL: string = null;
  cancelText: string = null;
  cancelCardType: string = null;
  tourAvailableDate: string = null;
  mapLocations: string[] = [];
  isLoaded: boolean = false;
  tourStartTimes: zoneTourStartTimes;

  constructor(private router: Router, private applicationService: ApplicationDataService, private prospectService: ProspectService, private eventEmitterService: EventEmitterService,
    private errorService: ErrorService, public dialog: MatDialog) {

    localStorage.removeItem("PropertyAddress");
    localStorage.removeItem("TourYardiKey");
    localStorage.removeItem("TourType");
    localStorage.removeItem("YardiID");
    localStorage.removeItem("SelfTourKey");

    this.prospectService.getOpenHousesForTourDash().subscribe(res => this.onGetOpenHouses(res), err => this.errorService.showError(err));
    this.eventEmitterService.selfTourModalCloseChangeEmitted$.subscribe(res => this.updateModalClose(res))

  }

  ngOnInit() {
  }

  async onGetOpenHouses(openHouses: ProspectTourCard[]) {
    for (const element of openHouses) {
      let prop = await this.applicationService.getProperty(element.YardiKey).toPromise();
      element.PropViewCard = { ...prop.results[0], sqft: `${prop.results[0].sqft}` };
      element.PropViewCard.sqft = element.PropViewCard.sqft.toLocaleString();
      element.PropViewCard.rent = element.PropViewCard.rent.toLocaleString();
      element.Flip = true;
      element.TourMonth = (element.TourMonth) ? element.TourMonth.toUpperCase() : null;
      this.tourCards.push(element);
    }
    this.prospectService.getShowingsForTourDash().subscribe(res => this.onGetShowings(res), res => this.errorMessage = "Error pulling tour dashboard values.")
  }

  async onGetShowings(showings: ProspectTourCard[]) {
    for (const element of showings) {
      let prop = await this.applicationService.getPropertyForShowing(element.YardiKey).toPromise();
      element.PropViewCard = { ...prop.results[0], sqft: `${prop.results[0].sqft}` };
      element.Flip = true;
      element.TourMonth = (element.TourMonth) ? element.TourMonth.toUpperCase() : null;
      this.tourCards.push(element);
    }

    let currentDate = new Date();
    let userOffset = currentDate.getTimezoneOffset();
    let userDate = currentDate.toDateString();

    this.prospectService.GetSelfToursForTourDash(userOffset, userDate).subscribe(res => this.onGetSelfToursForTourDash(res), res => this.errorMessage = "Error pulling tour dashboard values.")
  }

  async onGetSelfToursForTourDash(tours: ProspectTourCard[]) {
    for (const element of tours) {
      let prop = await this.applicationService.getProperty(element.YardiKey).toPromise();
      element.PropViewCard = { ...prop.results[0], sqft: `${prop.results[0].sqft}` };
      element.PropViewCard.sqft = element.PropViewCard.sqft.toLocaleString();
      element.PropViewCard.rent = element.PropViewCard.rent.toLocaleString();
      element.Flip = true;
      element.TourMonth = (element.TourMonth) ? element.TourMonth.toUpperCase() : null;
      this.tourCards.push(element);
    }

    let defaultCard = new ProspectTourCard();
    defaultCard.LoadDefaultCard();
    this.tourCards.push(defaultCard);
    this.getMapLocations(this.tourCards);
  }

  getMapLocations(tours: ProspectTourCard[]) {
    for (const tour of tours) {
      if (tour.YardiKey !== "") {
        this.mapLocations.push(tour.YardiKey);
      }
    }

    //delay loading of map until locations are populated
    this.isLoaded = true;
  }

  openLocationVerifyDialog() {
    const dialogRef = this.dialog.open(LocateAgreeComponent);

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openTourCalendarDialog(tour: ProspectTourCard) {
    localStorage.setItem('PropertyAddress', tour.AddressLine1);
    localStorage.setItem('TourType', tour.CardType.toLowerCase());
    localStorage.setItem('RecordKey', tour.RecordKey.toString());

    const dialogRef = this.dialog.open(AddTourToCalendarComponent);

    dialogRef.afterClosed().subscribe(result => {
      localStorage.removeItem('PropertyAddress');
      localStorage.removeItem('TourType');
      localStorage.removeItem('RecordKey');
    });
  }

  openSelfTourCalendarDialog(tour: ProspectTourCard) {
    localStorage.setItem('SelfTourKey', tour.RecordKey.toString());
    const dialogRef = this.dialog.open(AddSelfTourToCalendarComponent);

    dialogRef.afterClosed().subscribe(result => {
      localStorage.removeItem('SelfTourKey');
    });
  }


  viewHome(tour: ProspectTourCard) {
    let card = tour;

    if (card.IsMF && card.PropViewCard.link != null) {
      window.open(card.PropViewCard.link);
    }
    else if (card.HomeURL != null) {
      window.open(card.HomeURL);
    }
  }

  cancelShowing() {
    this.prospectService.cancelShowing(this.cancelRecordKey).subscribe(res => this.onCancelRecord(), res => this.errorService.showError("Error cancelling showing."));
  }

  onCancelRecord() {
    window.location.reload();
  }

  cancelTour(tour: ProspectTourCard) {
    this.cancelRecordKey = tour.RecordKey;
    this.cancelCardType = tour.CardType;
    this.cancelRedirectURL = tour.HomeURL;

    if (this.cancelCardType === "OpenHouse") {
      this.cancelText = "open house";
      this.prospectService.cancelOpenHouse(this.cancelRecordKey).subscribe(res => this.onCancelRecord(), res => this.errorService.showError("Error cancelling open house."));
    }
    else if (this.cancelCardType === "Showing") {
      this.cancelText = "showing";
      this.prospectService.cancelShowing(this.cancelRecordKey).subscribe(res => this.onCancelRecord(), res => this.errorService.showError("Error cancelling showing."));
    }
  }

  OnCanUserStartTour(result: boolean){
    if(result){
      this.prospectService.CheckForLocationAgreement().subscribe(res => this.onCheckForLocationAgreement(res), err => this.errorService.showError(err));
    } else {
      this.prospectService.getPropertyZone(localStorage.getItem("YardiID")).subscribe(res => this.onGetPropertyZonesToShowInError(res), res => this.errorService.showError(res));
    }
  }

  onGetPropertyZonesToShowInError(res: zoneTourStartTimes) {
    this.tourStartTimes = res;
    var earliest = new Date()
    earliest.setHours(this.tourStartTimes.SelfTourStartHour, this.tourStartTimes.SelfTourStartMinute, 0)
    var latest = new Date()
    latest.setHours(this.tourStartTimes.SelfTourEndHour, this.tourStartTimes.SelfTourEndMinute, 0)
    this.errorService.showError("We're sorry. This property's self-tour time is from " + earliest.toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit'}) + " to " + latest.toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit'}) + ".");
  }

  startSelfTour(tour: ProspectTourCard) {
    if (tour !== null) {
      localStorage.setItem('PropertyAddress', tour.AddressShort);
      localStorage.setItem('TourYardiKey', tour.YardiKey);
      localStorage.setItem('YardiID', tour.YardiKey);
      localStorage.setItem('SelfTourKey', tour.RecordKey.toString());
      var date = new Date().toLocaleString();
      this.prospectService.canUserStartTour(tour.RecordKey, date).subscribe(res => this.OnCanUserStartTour(res), err => this.errorService.showError(err))

    }
    else {
      this.errorMessage = "Error starting tour.";
      this.errorService.showError(this.errorMessage)
    }
  }

  onCheckForLocationAgreement(result: boolean) {
    if (result) {
      this.router.navigate(['/tour/selftour-start/verify-location']);
    }
    else {
      this.router.navigate(['/tour/selftour-start/locate-agree']);
    }
  }

  updateModalClose(result: boolean) {
    this.showTourModal = result;
  }

}